import i18n from 'infrastructure/i18n';

export enum States {
  Alabama = 'Alabama',
  Alaska = 'Alaska',
  AmericanSamoa = 'American Samoa',
  Arizona = 'Arizona',
  Arkansas = 'Arkansas',
  California = 'California',
  Colorado = 'Colorado',
  Connecticut = 'Connecticut',
  Delaware = 'Delaware',
  DistrictOfColumbia = 'District Of Columbia',
  FederatedStatesOfMicronesia = 'Federated States Of Micronesia',
  Florida = 'Florida',
  Georgia = 'Georgia',
  Guam = 'Guam',
  Hawaii = 'Hawaii',
  Idaho = 'Idaho',
  Illinois = 'Illinois',
  Indiana = 'Indiana',
  Iowa = 'Iowa',
  Kansas = 'Kansas',
  Kentucky = 'Kentucky',
  Louisiana = 'Louisiana',
  Maine = 'Maine',
  MarshallIslands = 'Marshall Islands',
  Maryland = 'Maryland',
  Massachusetts = 'Massachusetts',
  Michigan = 'Michigan',
  Minnesota = 'Minnesota',
  Mississippi = 'Mississippi',
  Missouri = 'Missouri',
  Montana = 'Montana',
  Nebraska = 'Nebraska',
  Nevada = 'Nevada',
  NewHampshire = 'New Hampshire',
  NewJersey = 'New Jersey',
  NewMexico = 'New Mexico',
  NewYork = 'New York',
  NorthCarolina = 'North Carolina',
  NorthDakota = 'North Dakota',
  NorthernMarianaIslands = 'Northern Mariana Islands',
  Ohio = 'Ohio',
  Oklahoma = 'Oklahoma',
  Oregon = 'Oregon',
  Palau = 'Palau',
  Pennsylvania = 'Pennsylvania',
  PuertoRico = 'Puerto Rico',
  RhodeIsland = 'Rhode Island',
  SouthCarolina = 'South Carolina',
  SouthDakota = 'South Dakota',
  Tennessee = 'Tennessee',
  Texas = 'Texas',
  Utah = 'Utah',
  Vermont = 'Vermont',
  VirginIslands = 'Virgin Islands',
  Virginia = 'Virginia',
  Washington = 'Washington',
  WestVirginia = 'West Virginia',
  Wisconsin = 'Wisconsin',
  Wyoming = 'Wyoming',
  None = 'none',
  All = 'all',
  MultiStateLicense = 'multi-state-license',
}

export const stateAbbreviations: Record<States, string> = {
  [States.Alabama]: i18n.t('stateAbbreviations.Alabama'),
  [States.Alaska]: i18n.t('stateAbbreviations.Alaska'),
  [States.AmericanSamoa]: i18n.t('stateAbbreviations.AmericanSamoa'),
  [States.Arizona]: i18n.t('stateAbbreviations.Arizona'),
  [States.Arkansas]: i18n.t('stateAbbreviations.Arkansas'),
  [States.California]: i18n.t('stateAbbreviations.California'),
  [States.Colorado]: i18n.t('stateAbbreviations.Colorado'),
  [States.Connecticut]: i18n.t('stateAbbreviations.Connecticut'),
  [States.Delaware]: i18n.t('stateAbbreviations.Delaware'),
  [States.DistrictOfColumbia]: i18n.t('stateAbbreviations.DistrictOfColumbia'),
  [States.FederatedStatesOfMicronesia]: i18n.t(
    'stateAbbreviations.FederatedStatesOfMicronesia',
  ),
  [States.Florida]: i18n.t('stateAbbreviations.Florida'),
  [States.Georgia]: i18n.t('stateAbbreviations.Georgia'),
  [States.Guam]: i18n.t('stateAbbreviations.Guam'),
  [States.Hawaii]: i18n.t('stateAbbreviations.Hawaii'),
  [States.Idaho]: i18n.t('stateAbbreviations.Idaho'),
  [States.Illinois]: i18n.t('stateAbbreviations.Illinois'),
  [States.Indiana]: i18n.t('stateAbbreviations.Indiana'),
  [States.Iowa]: i18n.t('stateAbbreviations.Iowa'),
  [States.Kansas]: i18n.t('stateAbbreviations.Kansas'),
  [States.Kentucky]: i18n.t('stateAbbreviations.Kentucky'),
  [States.Louisiana]: i18n.t('stateAbbreviations.Louisiana'),
  [States.Maine]: i18n.t('stateAbbreviations.Maine'),
  [States.MarshallIslands]: i18n.t('stateAbbreviations.MarshallIslands'),
  [States.Maryland]: i18n.t('stateAbbreviations.Maryland'),
  [States.Massachusetts]: i18n.t('stateAbbreviations.Massachusetts'),
  [States.Michigan]: i18n.t('stateAbbreviations.Michigan'),
  [States.Minnesota]: i18n.t('stateAbbreviations.Minnesota'),
  [States.Mississippi]: i18n.t('stateAbbreviations.Mississippi'),
  [States.Missouri]: i18n.t('stateAbbreviations.Missouri'),
  [States.Montana]: i18n.t('stateAbbreviations.Montana'),
  [States.Nebraska]: i18n.t('stateAbbreviations.Nebraska'),
  [States.Nevada]: i18n.t('stateAbbreviations.Nevada'),
  [States.NewHampshire]: i18n.t('stateAbbreviations.NewHampshire'),
  [States.NewJersey]: i18n.t('stateAbbreviations.NewJersey'),
  [States.NewMexico]: i18n.t('stateAbbreviations.NewMexico'),
  [States.NewYork]: i18n.t('stateAbbreviations.NewYork'),
  [States.NorthCarolina]: i18n.t('stateAbbreviations.NorthCarolina'),
  [States.NorthDakota]: i18n.t('stateAbbreviations.NorthDakota'),
  [States.NorthernMarianaIslands]: i18n.t(
    'stateAbbreviations.NorthernMarianaIslands',
  ),
  [States.Ohio]: i18n.t('stateAbbreviations.Ohio'),
  [States.Oklahoma]: i18n.t('stateAbbreviations.Oklahoma'),
  [States.Oregon]: i18n.t('stateAbbreviations.Oregon'),
  [States.Palau]: i18n.t('stateAbbreviations.Palau'),
  [States.Pennsylvania]: i18n.t('stateAbbreviations.Pennsylvania'),
  [States.PuertoRico]: i18n.t('stateAbbreviations.PuertoRico'),
  [States.RhodeIsland]: i18n.t('stateAbbreviations.RhodeIsland'),
  [States.SouthCarolina]: i18n.t('stateAbbreviations.SouthCarolina'),
  [States.SouthDakota]: i18n.t('stateAbbreviations.SouthDakota'),
  [States.Tennessee]: i18n.t('stateAbbreviations.Tennessee'),
  [States.Texas]: i18n.t('stateAbbreviations.Texas'),
  [States.Utah]: i18n.t('stateAbbreviations.Utah'),
  [States.Vermont]: i18n.t('stateAbbreviations.Vermont'),
  [States.VirginIslands]: i18n.t('stateAbbreviations.VirginIslands'),
  [States.Virginia]: i18n.t('stateAbbreviations.Virginia'),
  [States.Washington]: i18n.t('stateAbbreviations.Washington'),
  [States.WestVirginia]: i18n.t('stateAbbreviations.WestVirginia'),
  [States.Wisconsin]: i18n.t('stateAbbreviations.Wisconsin'),
  [States.Wyoming]: i18n.t('stateAbbreviations.Wyoming'),
  [States.None]: '',
  [States.All]: '',
  [States.MultiStateLicense]: '',
};
